import { apiUrl } from '../config';
import { fetch, upload} from '../utils/http';

export function clearUploadData() {
    return {
        type : 'UPLOAD_CLEAR_DATA',
    }
}

export function uploadFileSelected(file) {
    return {
        type : 'UPLOAD_FILE_SELECTED',
        file,
    }
}

export function uploadFileCancel() {
    return {
        type : 'UPLOAD_FILE_CANCEL',
    }
}

export function uploadFileStart(xhr) {
    return {
        type : 'UPLOAD_FILE_START',
        xhr
    }
}

export function uploadFileSuccess(upload) {
    return {
        type : 'UPLOAD_FILE_SUCCESS',
        upload
    }
}

export function uploadFileFailure(error) {
    return {
        type : 'UPLOAD_FILE_FAILURE',
        error
    }
}

export function uploadFileProgress(progress) {
    return {
        type : 'UPLOAD_FILE_PROGRESS',
        progress
    }
}

export function uploadFile(file, data) {
    const url = `${apiUrl()}/uploads`;
    return function(dispatch) {
        const xhr = upload(
            url,
            file,
            (evt) => {
                dispatch(uploadFileSuccess(evt));
            },
            (evt) => {
                dispatch(uploadFileFailure(evt));
            },
            (evt) => {
                dispatch(uploadFileProgress(100 * evt.loaded /evt.total));
            },
            (evt) => {
                dispatch(uploadFileCancel());
            },
            data
        );
        dispatch(uploadFileStart(xhr));
        
    }
}

export function fetchUploads(page = 1) {
    const url = `${apiUrl()}/uploads`;
    return function(dispatch) {
        dispatch(fetchUploadsStart());
    
        fetch(url, {
            method : 'GET',
            queryParams : { page : page }
        })
        .then(response => response.json())
        .then(data => dispatch(fetchUploadsSuccess(data)))
        .catch(error => dispatch(fetchUploadsFailure(error)));
    }
}

export function fetchUploadsStart() {
    return {
        type : 'UPLOADS_FETCH_START'
    }
}

export function fetchUploadsSuccess(data) {
    return {
        type : 'UPLOADS_FETCH_SUCCESS',
        data
    }
}

export function fetchUploadsFailure(error) {
    return {
        type : 'UPLOADS_FETCH_FAILURE',
        error,
    }
}


export function fetchUpload(upload_id) {
    const url = `${apiUrl()}/uploads/${upload_id}`;
    return function(dispatch) {
        dispatch(fetchUploadStart());
    
        fetch(url)
        .then(response => response.json())
        .then(data => dispatch(fetchUploadSuccess(data)))
        .catch(error => dispatch(fetchUploadFailure(error)));
    }
}

export function fetchUploadStart() {
    return {
        type : 'UPLOAD_FETCH_START'
    }
}

export function fetchUploadSuccess(upload) {
    return {
        type : 'UPLOAD_FETCH_SUCCESS',
        upload
    }
}

export function fetchUploadFailure(error) {
    return {
        type : 'UPLOAD_FETCH_FAILURE',
        error,
    }
}


export function fetchUploadMessages(upload_id, page = 1) {
    const url = `${apiUrl()}/uploads/${upload_id}/messages`;
    return function(dispatch) {
        dispatch(fetchUploadMessagesStart());
    
        fetch(url, {
            method : 'GET',
            queryParams : {
                page
            }
        })
        .then(response => response.json())
        .then(data => dispatch(fetchUploadMessagesSuccess(data)))
        .catch(error => dispatch(fetchUploadMessagesFailure(error)));
    }
}

export function fetchUploadMessagesStart() {
    return {
        type : 'UPLOADMSGS_FETCH_START'
    }
}

export function fetchUploadMessagesSuccess(data) {
    return {
        type : 'UPLOADMSGS_FETCH_SUCCESS',
        data
    }
}

export function fetchUploadMessagesFailure(error) {
    return {
        type : 'UPLOADMSGS_FETCH_FAILURE',
        error,
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/uploads.js
 **/